import React from 'react';
import PropTypes from 'prop-types';
import TextAreaNested from '../Form/TextAreaNexted';
const NewsletterInputs = ({ news, setNews }) => {
  return (
    <>
      <TextAreaNested
        title="Newsletter Title"
        name="newsletterTitle"
        value={news?.newsletterTitle}
        nestedValue={setNews}
        upperValue={news}
        containerClassName="formInputUnderline"
      />
      <TextAreaNested
        title="Month"
        name="month"
        value={news?.month}
        nestedValue={setNews}
        upperValue={news}
        containerClassName="formInputUnderline"
      />
      <TextAreaNested
        title="Title 1"
        name="title1"
        value={news?.title1}
        nestedValue={setNews}
        upperValue={news}
        containerClassName="formInputUnderline"
      />
      <TextAreaNested
        title="Content 1"
        name="content1"
        value={news?.content1}
        nestedValue={setNews}
        upperValue={news}
        containerClassName="formInputUnderline"
      />
      <TextAreaNested
        title="Title 2"
        name="title2"
        value={news?.title2}
        nestedValue={setNews}
        upperValue={news}
        containerClassName="formInputUnderline"
      />
      <TextAreaNested
        title="Content 2"
        name="content2"
        value={news?.content2}
        nestedValue={setNews}
        upperValue={news}
        containerClassName="formInputUnderline"
      />
      <TextAreaNested
        title="Title 3"
        name="title3"
        nestedValue={setNews}
        upperValue={news}
        value={news?.title3}
        containerClassName="formInputUnderline"
      />

      <TextAreaNested
        title="Content 3"
        name="content3"
        nestedValue={setNews}
        upperValue={news}
        value={news?.content3}
        containerClassName="formInputUnderline"
      />
    </>
  );
};
NewsletterInputs.propTypes = {
  news: PropTypes.shape({
    newsletterTitle: PropTypes.string,
    month: PropTypes.string,
    title1: PropTypes.string,
    content1: PropTypes.string,
    title2: PropTypes.string,
    content2: PropTypes.string,
    title3: PropTypes.string,
    content3: PropTypes.string,
  }),
  setNews: PropTypes.func,
};

export default NewsletterInputs;
